
import './index.css';
import keys from 'keys';

import { useCallback, useState, useEffect, useRef } from 'react';
import { encode } from 'base64-arraybuffer'

import { DocumentEditorContainerComponent, Toolbar } from '@syncfusion/ej2-react-documenteditor';
import { TitleBar } from './TitleBar';
import { registerLicense } from '@syncfusion/ej2-base';

import Axios from 'axios';

import Circle from 'components/markup/loading/Circle'

import Fields from './Fields'

registerLicense('Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH9dcHVWR2ZeUUNzWEA=');

DocumentEditorContainerComponent.Inject(Toolbar);

const Default = ({ match }) => {
  
    const hostUrl = "https://services.syncfusion.com/react/production/api/documenteditor/";
    const container = useRef(null);

    const [loading, setLoading] = useState(true)
    const [err, setErr] = useState(false)

    const fetchDocument = useCallback(async (cb) => {
        if(!match.params.word_document) return cb()
        let url = keys.API_URL + `/v1/word_documents/${match.params.word_document}/download`;

        const result = await Axios({
            method: 'get',
            url: url,
            responseType:'arraybuffer',
            headers: {
                authorization: `Bearer ${keys.SYSTEM_API_KEY}`
            },
            withCredentials: true,
        })

        if(result.headers && result.headers['content-type'].includes('application/json')) {
            try {
                var decodedString = String.fromCharCode.apply(null, new Uint8Array(result.data));
                var body = JSON.parse(decodedString);
                setErr(body)
            } catch(e) {
                console.log(e)
                setErr(`Unknown error`)
            }
            cb(null)
        }

        return cb(result)
    }, [match.params.word_document])

    useEffect(() => {
        console.log('hasdfasdf')
        // window.onbeforeunload = function () {
        //     return "Want to save your changes?";
        // };

        container.current.documentEditor.pageOutline = "#E0E0E0";
        container.current.documentEditor.acceptTab = true;
        container.current.documentEditor.resize();


        fetchDocument((result) => {


            setLoading(false);

            const titleBar = new TitleBar(document.getElementById("documenteditor_titlebar"), container.current.documentEditor, true, false, false, container.current, match.params)

            let name = 'New Document.docx'

            if(result && result.data) {
                if(result.data.success === false) return setErr(true)
                const base64 = encode(result.data)
                container.current.documentEditor.open(base64);

                if(result.headers && result.headers.filename) {
                    try {
                        name = result.headers.filename.replace('attachment; filename="', '').replace(/"/g, '')
                    } catch(e) {
                        console.log(e)
                    }
                }

            }

            container.current.documentEditor.documentName = name;
            titleBar.updateDocumentTitle();
            container.current.documentChange = () => {
                titleBar.updateDocumentTitle();
                container.current.documentEditor.focusIn();
            };
        })
       

    // eslint-disable-next-line
    }, []);
    
    if(err) return (
        <div className='alert alert-danger text-center text-white' style={{fontSize: 16}}>
            Something went wrong loading this document or the document could not be found. Please refresh your page or visit your admin dashboard for a correct link
        </div>
    )

    return (
        <>
        <div className="control-pane">
            {loading ? <Circle /> : ''}
            <div className="control-section" style={{display: loading ? 'none' : 'block'}}>
                <div id="documenteditor_titlebar" className="e-de-ctn-title" />
                <div id="documenteditor_container_body">
                    <DocumentEditorContainerComponent 
                        id="container" 
                        ref={container} 
                        style={{ display: "block" }} 
                        height={"100vh"} 
                        serviceUrl={hostUrl} 
                        enableToolbar={true} 
                        locale="en-US"
                    />
                </div>
            </div>

        </div>
        <Fields />

        </>
    );
};
export default Default;